import styled from "styled-components";

export const InfoContainer = styled.div`
  margin-top: 0.3rem;
`;
export const InfoHeader = styled.h5`
  font-weight: bold;
  margin: 0;
  margin-bottom: 0.175rem;
`;

export const InfoRow = styled.p`
  margin-bottom: 0.2rem;
`;
export const InfoSeparator = styled.hr`
  color: ${(props) => props.color}; /* old IE */
  width: 100%;
  height: 2px;
  background-color: ${(props) => props.color}; /* Modern Browsers */
  margin-bottom: 0.5rem;
  margin-top: 0;
  border: 0;
`;
